import { ComponentProps, RefObject, forwardRef } from 'react'
import { TextField } from 'ui-components-web'

type FormInputProps = ComponentProps<typeof TextField>

export const FormInput = forwardRef<RefObject<HTMLInputElement>, FormInputProps>(({ name, ...props }, ref) => {
  return <TextField variant="outlined" label="" fullWidth inputProps={{ name }} inputRef={ref} {...props} />
})
FormInput.displayName = 'FormInput'

export default FormInput
